import PropTypes from 'prop-types';
import Slide from '@mui/material/Slide';
import { CrossBoldSvg } from '../../assets/svgs';
import { ModalBody, ModalCloseButton, ModalContainer, ModalHead, ModalHeadTop, ModalMain, ModalOverlay, SliderRow } from './modal.style';
import SliderComponent from "../slider";

const ModalComponent = ({ type = 'default', label = 'Modal title here', width = 600, close, children, slide, barSlider, barSliderValue = 0 }) => {
    const MODAL_CONTAINER = () => (
        <ModalContainer width={width} $slide={slide}>
            {/* Head */}
            <ModalHead type={type}>
                <ModalHeadTop>
                    <h4>{label}</h4>
                    <ModalCloseButton onClick={close}>
                        <CrossBoldSvg />
                    </ModalCloseButton>
                </ModalHeadTop>
                {barSlider && (
                    <SliderRow>
                        { /* */ }
                        <span>Weightage (total must be 100):</span>
                        <SliderComponent value={barSliderValue} thumb={false} displayValue={true} />
                    </SliderRow>
                )}
            </ModalHead>
            {/* Body */}
            <ModalBody>
                {children ? children : <i>Modal body here</i>}
            </ModalBody>
        </ModalContainer>
    );

    return (
        <ModalOverlay>
            <ModalMain $slide={slide}>
                {
                    slide ? (
                        <Slide direction="left" in={slide} mountOnEnter unmountOnExit>
                            {MODAL_CONTAINER()}
                        </Slide>
                    ) : (
                        <>
                            {MODAL_CONTAINER()}
                        </>
                    )
                }
            </ModalMain>
        </ModalOverlay>
    );
};

ModalComponent.propTypes = {
    type: PropTypes.oneOf(['default', 'success', 'error', 'warning']),
    label: PropTypes.string,
    width: PropTypes.number,
    slide: PropTypes.bool,
    barSlider: PropTypes.bool,
    barSliderValue: PropTypes.number,
};

export default ModalComponent;
